import React from "react";

function Footer() {
  return (
    <>
      <div className="footer">
        <p>©2020 www.ongshondigital.com All Rights Reserved.</p>
      </div>
    </>
  );
}

export default Footer;
